<template>
    <el-dialog :close-on-click-modal="false" title="添加资源" :visible.sync="dialogVisible" width="130rem"
        :before-close="handleClose">
        <div class="top-box">
            <p style="color: #8590B3;">教学单元：</p>
            <div>{{ teachUnit.name }}</div>
            <div class="type-label" :style="`color:rgb(56, 125, 255);background-color:rgba(56, 125, 255,0.1);`">仿真</div>
            <el-radio-group v-model="radio" @change="changeMethod" style="margin-left: 4rem;">
                <el-radio :label="3">按步骤添加</el-radio>
                <el-radio :label="0">全局添加</el-radio>
            </el-radio-group>
        </div>
        <div class="radio-box">
            <div>资源类型：</div>
            <el-radio-group v-model="classifyCode" @input="changeCategory">
                <el-radio v-for="(item, index) in catagoryList" :key="index" :label="item.value">{{ item.label
                    }}</el-radio>
            </el-radio-group>
        </div>
        <div class="content-box">
            <div class="left-box">
                <tree-component :treeData="treeData" :currentId="currentId"></tree-component>
            </div>
            <div class="right-box">
                <div class="input-box" v-if="activeName != 'local'">
                    <div @click="handleClick">搜索</div>
                    <el-input v-model="keywords" @keydown.enter.native="handleClick" clearable @clear="handleClick" placeholder="请输入关键字">
                        <img slot="prefix" class="search-img" src="../../../assets/image/magSys/search.png" @click="handleClick" alt="">
                    </el-input>
                </div>
                <el-tabs v-model="activeName" @tab-click="changeTab">
                    <el-tab-pane :label="`个人资源库（${resNum[2]}）`" name="myself">
                        <div class="box-content">
                            <div class="left-box-container">
                                <div v-for="(item, index) in resourceType" style="position: relative;"
                                    @click="changeType(index)" :key="index">
                                    <el-tooltip class="item" v-if="staticsNumber(index)>0" effect="dark" :content="'已绑定资源数量：'+staticsNumber(index)" placement="top-start">
                                        <p class="num1">{{ staticsNumber(index) }}</p>
                                    </el-tooltip>
                                    <el-tooltip class="item" effect="dark" :content="'资源数量：'+getResNum(index)" placement="top-start">
                                        <p class="num2" style="cursor: pointer;"
                                            :class="{ 'active': index == currentType }">{{ `（${getResNum(index)<100?getResNum(index):'99+'}）` }}</p>
                                    </el-tooltip>
                                    <el-tooltip effect="dark" :content="index" placement="top-start">
                                        <img class="type-img-style" :src="index == currentType?imgList[item]:imgList['no-'+item]" alt="">
                                    </el-tooltip>
                                </div>
                            </div>
                            <div class="right-box-container">
                                <div class="select-box">
                                    <div v-for="(item, index) in filterSelctList" class="select-item" :key="index">
                                        <el-tooltip class="item" effect="dark" :content="item.resourceName"
                                            placement="top-start">
                                            <div slot="content">
                                                <div v-html="item.resourceName"></div>
                                            </div>
                                            <p class="overflow html-ev" style="width: 7.5rem;" v-html="item.resourceName"></p>
                                        </el-tooltip>
                                        <i class="resource-name el-icon-close" style="cursor: pointer;"
                                            @click="delResource(item)"></i>
                                    </div>
                                    <div v-if="filterSelctList.length == 0" class="tip-box">
                                        <i class="iconfont icon-gantanhao-yuankuang"></i>
                                        <p>点选下方文件，添加资源</p>
                                    </div>
                                </div>
                                <div class="table-box">
                                    <div v-for="(item, index) in tableData" class="table-item" @click="selectRes(item)"
                                        :key="index">
                                        <div class="cover-box">
                                            <img :class="{ 'active-img': isSelect(item.id) }" class="res-img"
                                                :src="item.coverPath ? $severUrl(item.coverPath) : $filterResDefault(item.type)"
                                                alt="">
                                        </div>
                                        <el-tooltip effect="dark" v-if="item.type=='题库'" placement="top-start">
                                            <div slot="content"  v-html="item.resourceName"></div>
                                            <div v-html="item.resourceName" style="margin-top: 0.5rem;" class="overflow html-ev"
                                                :class="{ 'active-select': isSelect(item.id) }"></div>
                                        </el-tooltip>
                                        <el-tooltip v-else effect="dark" :content="item.resourceName" placement="top-start">
                                            <div style="margin-top: 0.5rem;" class="overflow"
                                                :class="{ 'active-select': isSelect(item.id) }">{{
                                                    item.resourceName }}</div>
                                        </el-tooltip>
                                    </div>
                                </div>
                                <div class="page-box" v-if="tableData.length > 0">
                                    <el-pagination background :current-page="pages.current" :page-size="pages.size" layout="prev, pager, next" @current-change="changeCurrent"
                                        :total="pages.total">
                                    </el-pagination>
                                </div>
                                <no-data v-else></no-data>
                            </div>
                        </div>
                    </el-tab-pane>
                    <el-tab-pane :label="`院校资源库（${resNum['1']}）`" name="college">
                        <div class="box-content">
                            <div class="left-box-container">
                                <div v-for="(item, index) in resourceType" style="position: relative;"
                                    @click="changeType(index)" :key="index">
                                    <el-tooltip class="item" v-if="staticsNumber(index)>0" effect="dark" :content="'已绑定资源数量：'+staticsNumber(index)" placement="top-start">
                                        <p class="num1">{{ staticsNumber(index) }}</p>
                                    </el-tooltip>
                                    <el-tooltip class="item" effect="dark" :content="'资源数量：'+getResNum(index)" placement="top-start">
                                        <p class="num2" style="cursor: pointer;"
                                            :class="{ 'active': index == currentType }">{{ `（${getResNum(index)<100?getResNum(index):'99+'}）` }}</p>
                                    </el-tooltip>
                                    <el-tooltip effect="dark" :content="index" placement="top-start">
                                        <img class="type-img-style" :src="index == currentType?imgList[item]:imgList['no-'+item]" alt="">
                                    </el-tooltip>
                                </div>
                            </div>
                            <div class="right-box-container">
                                <div class="select-box">
                                    <div v-for="(item, index) in filterSelctList" class="select-item" :key="index">
                                        <el-tooltip class="item" effect="dark" :content="item.resourceName"
                                            placement="top-start">
                                            <div slot="content"  v-html="item.resourceName"></div>
                                            <p class="overflow html-ev" style="width: 7.5rem;" v-html="item.resourceName"></p>
                                        </el-tooltip>
                                        <i class="resource-name el-icon-close" style="cursor: pointer;"
                                            @click="delResource(item)"></i>
                                    </div>
                                    <div v-if="filterSelctList.length == 0" class="tip-box">
                                        <i class="iconfont icon-gantanhao-yuankuang"></i>
                                        <p>点选下方文件，添加资源</p>
                                    </div>
                                </div>
                                <div class="table-box">
                                    <div v-for="(item, index) in tableData" class="table-item" @click="selectRes(item)"
                                        :key="index">
                                        <div class="cover-box">
                                            <img :class="{ 'active-img': isSelect(item.id) }" class="res-img"
                                                :src="item.coverPath ? $severUrl(item.coverPath) : $filterResDefault(item.type)"
                                                alt="">
                                        </div>
                                        <el-tooltip effect="dark" v-if="item.type=='题库'" placement="top-start">
                                            <div slot="content"  v-html="item.resourceName"></div>
                                            <div v-html="item.resourceName" style="margin-top: 0.5rem;" class="overflow html-ev"
                                                :class="{ 'active-select': isSelect(item.id) }"></div>
                                        </el-tooltip>
                                        <el-tooltip effect="dark" v-else :content="item.resourceName" placement="top-start">
                                            <div style="margin-top: 0.5rem;" class="overflow"
                                                :class="{ 'active-select': isSelect(item.id) }">{{
                                                    item.resourceName }}</div>
                                        </el-tooltip>
                                    </div>
                                </div>
                                <div class="page-box" v-if="tableData.length > 0">
                                    <el-pagination :current-page="pages.current" :page-size="pages.size" background layout="prev, pager, next" @current-change="changeCurrent"
                                        :total="pages.total">
                                    </el-pagination>
                                </div>
                                <no-data v-else></no-data>
                            </div>
                        </div>
                    </el-tab-pane>
                    <el-tab-pane :label="`平台资源库（${resNum['0']}）`" name="cloud">
                        <div class="box-content">
                            <div class="left-box-container">
                                <div v-for="(item, index) in resourceType" style="position: relative;"
                                    @click="changeType(index)" :key="index">
                                    <el-tooltip class="item" v-if="staticsNumber(index) > 0" effect="dark" :content="'已绑定资源数量：'+staticsNumber(index)" placement="top-start">
                                        <p class="num1">{{ staticsNumber(index) }}</p>
                                    </el-tooltip>
                                    <el-tooltip class="item" effect="dark" :content="'资源数量：'+getResNum(index)" placement="top-start">
                                        <p class="num2" style="cursor: pointer;"
                                            :class="{ 'active': index == currentType }">{{ `（${getResNum(index)<100?getResNum(index):'99+'}）` }}</p>
                                    </el-tooltip>
                                    <el-tooltip effect="dark" :content="index" placement="top-start">
                                        <img class="type-img-style" :src="index == currentType?imgList[item]:imgList['no-'+item]" alt="">
                                    </el-tooltip>
                                </div>
                            </div>
                            <div class="right-box-container">
                                <div class="select-box">
                                    <div v-for="(item, index) in filterSelctList" class="select-item" :key="index">
                                        <el-tooltip class="item" effect="dark" :content="item.resourceName"
                                            placement="top-start">
                                            <div slot="content"  v-html="item.resourceName"></div>
                                            <p class="overflow" style="width: 7.5rem;">{{ item.resourceName }}</p>
                                        </el-tooltip>
                                        <i class="resource-name el-icon-close" style="cursor: pointer;"
                                            @click="delResource(item)"></i>
                                    </div>
                                    <div v-if="filterSelctList.length == 0" class="tip-box">
                                        <i class="iconfont icon-gantanhao-yuankuang"></i>
                                        <p>点选下方文件，添加资源</p>
                                    </div>
                                </div>
                                <div class="table-box">
                                    <div v-for="(item, index) in tableData" class="table-item" @click="selectRes(item)"
                                        :key="index">
                                        <div class="cover-box">
                                            <img :class="{ 'active-img': isSelect(item.id) }" class="res-img"
                                                :src="item.coverPath ? $severUrl(item.coverPath) : $filterResDefault(item.type)"
                                                alt="">
                                        </div>
                                        <el-tooltip effect="dark" v-if="item.type=='题库'" placement="top-start">
                                            <div slot="content"  v-html="item.resourceName"></div>
                                            <div v-html="item.resourceName" style="margin-top: 0.5rem;" class="overflow html-ev"
                                                :class="{ 'active-select': isSelect(item.id) }"></div>
                                        </el-tooltip>
                                        <el-tooltip v-else effect="dark" :content="item.resourceName" placement="top-start">
                                            <div style="margin-top: 0.5rem;" class="overflow"
                                                :class="{ 'active-select': isSelect(item.id) }">{{
                                                    item.resourceName }}</div>
                                        </el-tooltip>
                                    </div>
                                </div>
                                <div class="page-box" v-if="tableData.length > 0">
                                    <el-pagination  :current-page="pages.current" :page-size="pages.size" background layout="prev, pager, next" @current-change="changeCurrent"
                                        :total="pages.total">
                                    </el-pagination>
                                </div>
                                <no-data v-else></no-data>
                            </div>
                        </div>
                    </el-tab-pane>
                    <el-tab-pane label="本地添加" name="local" v-if="currentType!='题库'">
                        <div class="box-content">
                            <div class="left-box-container">
                                <div v-for="(item, index) in resourceType" style="position: relative;"
                                    @click="changeType(index)" :key="index">
                                    <el-tooltip class="item" effect="dark" :content="'已绑定资源数量：'+staticsNumber(index)" placement="top-start">
                                        <p class="num1" v-if="staticsNumber(index) > 0">{{ staticsNumber(index) }}</p>
                                    </el-tooltip>
                                    <el-tooltip effect="dark" :content="index" placement="top-start">
                                        <img class="type-img-style" :src="index == currentType?imgList[item]:imgList['no-'+item]" alt="">
                                    </el-tooltip>
                                </div>
                            </div>
                            <div class="right-box-container">
                                <div style="display: flex;align-items: center;margin-bottom: 2rem;">
                                    <div>资源名称</div>
                                    <el-input style="width: 100%;margin-left: 2rem;" v-model="form.resourceName"
                                        placeholder="请输入资源名称"></el-input>
                                </div>
                                <div style="display: flex;align-items: center;margin-bottom: 2rem;">
                                    <div>资源简介</div>
                                    <el-input type="textarea" style="width: 100%;margin-left: 2rem;" v-model="form.info"
                                        placeholder="请输入资源名称"></el-input>
                                </div>
                                <div class="t-cover-box" v-if="currentType != '图片'">
                                    <div>资源封面</div>
                                    <el-upload style="width: 50px !important; height: 50px !important" action="#"
                                        accept=".jpg,.jpeg,.png" list-type="picture-card" :auto-upload="false"
                                        :show-file-list="false" class="upload-box-img" :on-change="uploadCover">
                                        <img v-if="form.coverPath" :src="$severUrl(form.coverPath)"
                                            style="width: 48px; height: 48px;object-fit: cover;" />
                                        <i v-else class="el-icon-plus"></i>
                                    </el-upload>
                                </div>
                                <div v-if="currentType == '仿真软件'"
                                    style="display: flex;align-items: center;margin-bottom: 2rem;">
                                    <div>资源链接</div>
                                    <el-input style="width: 100%;margin-left: 2rem;" v-model="form.resUrl"
                                        placeholder="请输入资源名称"></el-input>
                                </div>
                                <div v-else class="upload-box">
                                    <upload-chunk ref="chunk1" :multiple="false" :accept="uploadAccept"
                                        @upload="loaclUpload" @del_file="loaclUpload"></upload-chunk>
                                </div>
                            </div>
                        </div>
                    </el-tab-pane>
                    <el-tab-pane :label="`已绑资源（${selectList.length}）`" name="hasBind">
                        <Table :pagination="false" :serialNumber="false" :operationWidth="350"
                            :currentPage="hasBindRes.pages.current" :pageSize="hasBindRes.pages.size" navHeight=40
                            ref="table" :tableData="hasBindRes.tableData" :tableKey="hasBindRes.tableKey">
                            <template slot="bindResSource" slot-scope="data">
                                <p style="color: #000000;">{{ filterOrigin(data.data.row.bindResSource) }}</p>
                            </template>
                            <template slot="classifyCode" slot-scope="data">
                                <p style="color: #000000;">{{ filterCategory(data.data.row.classifyCode) }}</p>
                            </template>
                            <template slot="operation" slot-scope="data">
                                <div style="display: flex;">
                                    <div class="operation-text" @click="delResource(data.data.row)">解除绑定</div>
                                </div>
                            </template>
                        </Table>
                    </el-tab-pane>
                </el-tabs>
            </div>
        </div>
        <div slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false">取 消</el-button>
            <el-button type="primary" v-if="isConfirm" @click="save">保 存</el-button>
        </div>
    </el-dialog>
</template>

<script>
import TreeComponent from './TreeComponent.vue';
import { GetBindData, MainBindData, PageResourceList, MainUnbindData, AddResource, GetDataTypeResDataCount } from '@/api/resourceMag';
import { GetSoftwareModules } from '@/api/software';
import {resImg} from '@/utils/utils';
import Utils from '@/assets/js/Utils';
import {Category} from '@/utils/utils';
import { PageSubject } from '@/api/subject';
import UploadChunk from '../../common/UploadChunk.vue';
import { uploadFile } from '@/assets/js/oss';
export default {
    components: { TreeComponent, UploadChunk },
    props: {
        teachUnit: {
            require: true,
            default: () => { }
        }
    },
    data() {
        return {
            imgList:resImg(),
            /**资源数量 */
            resNum: {
                '0': 0,
                '1': 0,
                '2': 0
            },
            /**已绑资源模块 */
            hasBindRes: {
                pages: {
                    current: 1,
                    size: 10,
                    total: 0
                },
                tableData: [],
                tableKey: [
                    { name: '资源名称', value: 'resourceName' },
                    { name: '资源类型', value: 'type' },
                    {name: '所属分类', value: 'classifyCode',slot:'classifyCode'},
                    { name: '资源来源', value: 'bindResSource', slot: 'bindResSource' },
                    { name: '操作', value: 'operation', slot: 'operation' },
                ],
            },
            resNumStatistics: [],
            radio: 3,
            /**搜索关键字 */
            keywords: '',
            pages: {
                current: 1,
                size: 8,
                total: 0
            },
            dialogVisible: false,
            // 左侧树状结构
            treeData: [],
            /**资源类型 */
            classifyCode: 'CIS',
            /**所属分类 */
            catagoryList:Category,
            /**当前选中树结构Id */
            currentId: '',
            /**tab切换 */
            activeName: 'myself',
            /**资源类型 */
            resourceType: {
                '模型': 'mx',
                '动画': 'dh',
                '视频': 'sp',
                '图片': 'tp',
                '文档': 'wd',
                'ppt':'ppt',
                '题库': 'tk',
            },
            currentType: '模型',
            tableData: [],
            tableKey: [
                { name: '资源名称', value: 'resourceName', },
                { name: '资源类型', value: 'type', },
                { name: '添加方式', value: 'addType', slot: 'addType' },
                { name: '操作', value: 'operation', slot: 'operation' },
            ],
            selectList: [],
            /**用于对比id */
            selectObj: {},
            form: {
                "classifyCode": "",
                "coverPath": "",
                "info": "",
                "resUrl": "",
                "resourceName": '',
            }
        }
    },
    computed: {
        uploadAccept() {
            var obj = {
                '仿真软件': '.exe',
                '模型': '.fbx,.obj',
                '视频': '.mp4,.avi,.ts,.flv,.avi,.wmv',
                '图片': '.png,.jpg,.jpeg',
                '文档': ".doc,.docx,.pdf,.xls,.xlsx",
                'ppt': '.ppt,.pptx'
            }
            return obj[this.currentType];
        },
        isConfirm() {
            if (this.activeName == 'local') {
                return true;
            } else {
                return false;
            }
        },
        /**过滤已绑定资源类型 */
        filterSelctList() {
            return this.selectList.filter(item => item.type == this.currentType && item.classifyCode == this.classifyCode);
            // var obj = {
            //     0: 'cloud',
            //     1: 'college',
            //     2: 'myself'
            // }
            // return this.selectList.filter(item => item.type == this.currentType && item.classifyCode == this.classifyCode && obj[item.bindResSource] == this.activeName);
        }
    },
    methods: {
        /**过滤资源来源 */
        filterOrigin(type) {
            var obj = {
                0: '平台资源库',
                1: '院校资源库',
                2: '个人资源库'
            };
            return obj[type];
        },
          /**过滤所属分类 */
          filterCategory(type){
            var el=Category.find(item=>item.value==type);
            if(el){
                return el.label;
            }
        },
        /**统计该类型已绑定资源数量 */
        staticsNumber(type) {
            var obj = {
                0: 'cloud',
                1: 'college',
                2: 'myself'
            }
            return this.selectList.filter(item => item.type == type && item.classifyCode == this.classifyCode && obj[item.bindResSource] == this.activeName).length;
        },
        /**分页查询题库 */
        pageSubject(dataType) {
            var params = {
                "classifyCode": this.classifyCode,
                "current": this.pages.current,
                "dataType": dataType,
                "questionStem": this.keywords,
                "size": this.pages.size,
            }
            PageSubject(params).then(res => {
                if (res.code == 200) {
                    this.pages.total = res.data.total;
                    this.tableData = res.data.records.map(item => {
                        return {
                            id: item.id,
                            type: '题库',
                            resourceName: item.questionStem
                        }
                    });;
                }
            })
        },
        getResNum(type) {
            var obj = {
                cloud: 0,
                college: 1,
                myself: 2
            }
            var el = this.resNumStatistics.find(item => {
                return item.dataType == obj[this.activeName] && item.type == type;
            })
            if (el) {
                return el.count;
            } else {
                return 0;
            }
        },
        openInit() {
            this.radio=3;
            this.activeName = 'myself';
            this.currentType = '模型';
            this.keywords = '';
            this.classifyCode = this.$store.state.course.classifyCode;
        },
        /**本地新增资源 */
        addResource() {
            var params = {
                "classifyCode": this.classifyCode,
                "coverFileId": this.form.coverFileId,
                "coverPath": this.form.coverPath,
                "fileIds": [this.form.fileId],
                "fileName": this.form.fileName,
                "info": this.form.info,
                "resUrl": "",
                "resourceCode": "",
                "resourceName": this.form.resourceName,
                "type": this.currentType
            };
            if (this.currentType == '图片') {
                delete params.coverPath;
            }
            AddResource(params).then(res => {
                if (res.code == 200) {
                    this.bindToResourceId(res.data, () => {
                        this.clearUpload();
                    });
                    this.getDataTypeResDataCount();
                }
            })
        },
        /**切换资源类型 */
        changeCategory() {
            this.pages.current=1;
            this.handleClick();
            this.getDataTypeResDataCount();
        },
        /**获取数据类型资源数量 */
        getDataTypeResDataCount() {
            var resTypeList = [];
            for (var key in this.resourceType) {
                resTypeList.push(key);
            }
            var params = {
                "classifyCode": this.classifyCode,
                "resTypeList": resTypeList
            };
            GetDataTypeResDataCount(params).then(res => {
                if (res.code == 200) {
                    var resNum = {
                        '0': 0,
                        '1': 0,
                        '2': 0
                    }
                    this.resNumStatistics = res.data;
                    for (var key in resNum) {
                        var arr = res.data.filter(item => item.dataType == key);
                        arr.forEach(item => {
                            resNum[key] = resNum[key] + item.count;
                        })
                    }
                    this.resNum = resNum;
                }
            })
        },
        /**本地上传清空表单 */
        clearUpload() {
            this.form.coverFileId = '';
            this.form.coverPath = '';
            this.form.fileId = '';
            this.form.fileName = '';
            this.form.info = '';
            this.form.url = '';
            this.form.resourceName = '';
            var upload = this.$refs.chunk1;
            if (upload) {
                upload.fileArr = [];
            }
        },
        /**判断是否为选中资源 */
        isSelect(id) {
            return this.selectObj[id];
        },
        /**教学单元主体资源绑定相关资源 */
        bindToResourceId(bindResId, callback) {
            var obj = {
                myself: 2,
                college: 1,
                cloud: 0,
                local: 2
            }
            var params = {
                "bindResId": bindResId,
                "bindResSource": obj[this.activeName],
                "bindResType": this.currentType,
                "bindType": this.radio,
                "nodeId": this.currentId,
                "resId": this.teachUnit.resourceId,
                "teachingUnitId": this.teachUnit.id
            }
            MainBindData(params).then(res => {
                if (res.code == 200) {
                    this.$msg({
                        showClose: true,
                        message: "添加资源成功",
                        type: "success",
                    });
                    this.getBindData();
                    this.queryBindData();
                    typeof callback == 'function' && callback();
                }
            })
        },
        /**查询主体资源已绑定资源 */
        getBindData() {
            if (this.radio && !this.currentId) return;
            var params = {
                "bindType": this.radio,
                "nodeId": this.currentId,
                "resId": this.teachUnit.resourceId
            };
            if (this.radio == 0) {
                params.teachingUnitId = this.teachUnit.id;
            }
            GetBindData(params).then(res => {
                if (res.code == 200) {
                    this.selectList = res.data;
                    var obj = {};
                    this.selectList.forEach(item => {
                        obj[item.originalResId] = true;
                    })
                    this.selectObj = obj;
                }
            })
        },
        /**查询已绑定资源列表 */
        queryBindData() {
            if (this.radio && !this.currentId) return;
            var params = {
                "bindType": this.radio,
                "nodeId": this.currentId,
                "resName": this.activeName == 'hasBind' ? this.keywords : '',
                "resId": this.teachUnit.resourceId
            };
            if (this.radio == 0) {
                params.teachingUnitId = this.teachUnit.id;
            }
            GetBindData(params).then(res => {
                if (res.code == 200) {
                    this.hasBindRes.tableData = res.data;
                }
            })
        },
        changeCurrent(e) {
            this.handleClick(e);
        },
        /**上传封面图 */
        uploadCover(e) {
            uploadFile(e.raw).then(res => {
                this.form.coverPath = res.previewUrl;
            })
        },
        /**分页查询基础资源 */
        pageResourceList(dataType) {
            var params = {
                "classifyCode": this.classifyCode,
                "current": this.pages.current,
                "dataType": dataType,
                "resourceName": this.keywords,
                "size": this.pages.size,
                "type": this.currentType
            };
            PageResourceList(params).then(res => {
                if (res.code == 200) {
                    this.pages.total = res.data.total;
                    this.tableData = res.data.records;
                }
            })
        },
        /**删除选中资源 */
        delResource(data) {
            MainUnbindData({ id: data.id }).then(res => {
                if (res.code == 200) {
                    this.getBindData();
                    this.queryBindData();
                }
            })
        },
        /**切换添加方式 */
        changeMethod() {
            if (this.radio == 0) {
                this.currentId = '';
            } else {
                if (this.treeData && this.treeData.length > 0) {
                    this.changeTree(this.findLastChild(this.treeData[0]));
                }
            }
            this.getBindData();
            this.queryBindData();
        },
        /**主体资源预览查询 */
        mainPreview(callback) {
            var params = {
                id: this.teachUnit.resourceId,
                type: this.teachUnit.dataType
            }
            GetSoftwareModules(params).then(res => {
                if (res.code == 200) {
                    this.treeData = res.data;
                    if (this.treeData && this.treeData.length > 0) {
                        this.changeTree(this.findLastChild(this.treeData[0]));
                    }
                    typeof callback == 'function' && callback();
                }
            })
        },
        findLastChild(data) {
            if (data.children && data.children.length > 0) {
                return this.findLastChild(data.children[0]);
            } else {
                return data.id;
            }
        },
        /**切换tab */
        changeTab() {
            this.keywords = '';
            this.handleClick();
        },
        /**搜索 */
        handleClick(e) {
            if (this.activeName == 'hasBind') {
                this.queryBindData();
                return;
            }
            this.pages.current = (typeof e=='number'?e:1);
            var obj = {
                myself: '2',
                college: '1',
                cloud: '0'
            }
            if (obj[this.activeName] === undefined) return;
            if (this.currentType == '题库') {
                this.pageSubject(obj[this.activeName]);
                return;
            }
            this.pageResourceList(obj[this.activeName]);
        },
        /**选中资源 */
        selectRes(item) {
            if (this.radio && !this.currentId) {
                this.$msg({
                    showClose: true,
                    message: "请先选择步骤",
                    type: "warning",
                });
                return;
            };
            if(this.selectObj[item.id]){
                let el=this.selectList.find(e=>e.originalResId==item.id);
                el&&this.delResource(el);
                return;
            };
            this.bindToResourceId(item.id);
        },
        /**基础云资源库分页查询 */
        pageCloudResource(isOpen) {
            var params = {
                "classifyCode": this.classifyCode,
                "current": this.pages.current,
                "courseMenuId": this.teachUnit.id,
                "resourceId": this.teachUnit.resourceId,
                "isOpen": isOpen,
                "resourceCode": "",
                "resourceName": "",
                "size": this.pages.size,
                "types": [this.currentType]
            };
            PageCloudResource(params).then(res => {
                if (res.code == 200) {
                    this.tableData = res.data.records;
                    this.pages.total = res.data.total;
                    this.showSelect();
                }
            })
        },
        /**已绑定资源分页查询 */
        PageBindResource() {
            var params = {
                "courseMenuId": this.teachUnit.id,
                "current": this.pages.current,
                "resourceId": this.teachUnit.resourceId,
                "type": this.currentType,
                "resourceName": "",
                "size": this.pages.size
            }
            PageBindResource(params).then(res => {
                if (res.code == 200) {
                    this.tableData = res.data.records;
                    this.pages.total = res.data.total;
                }
            })
        },
        save() {
            if (this.radio && !this.currentId) {
                this.$msg({
                    showClose: true,
                    message: "请先选择步骤",
                    type: "warning",
                });
                return;
            }
            this.addResource();
        },
        /**本地上传文件 */
        loaclUpload(files) {
            if (files.length == 0) {
                this.form.fileId = '';
            } else {
                this.form.fileId = files[0].fileId;
                this.form.fileName = files[0].fileName;
                if (!this.form.resourceName) {
                    this.form.resourceName = this.form.fileName;
                }
            }
        },
        changeTree(id) {
            this.currentId = id;
            this.getBindData();
            this.queryBindData();
        },
        handleClose() {
            this.dialogVisible = false;
        },
        changeType(index) {
            this.currentType = index;
            if(index=='题库'&&this.activeName=='local'){
                this.activeName='myself';
            }
            this.handleClick();
        }
    },
    mounted() {
        Utils.$on('change_tree', this.changeTree);
    },
    destroyed() {
        Utils.$off('change_tree', this.changeTree);
    }
}
</script>

<style lang="less" scoped>
.res-img{
    width: 100%;
    height: 100%;
    cursor: pointer;
    transition: all 0.3s;
}
/deep/.el-dialog__title {
    font-size: 16px;
    font-weight: 700;
    color: #334681;
}

.input-box {
    display: flex;
    align-items: center;
    position: absolute;
    right: 2rem;
    top: 1rem;
    z-index: 99;
    &> :nth-child(1) {
        margin-right: 1rem;
        cursor: pointer;
    }
}

.top-box {
    display: flex;
    align-items: center;
    padding-bottom: 3rem;
}

.type-label {
    text-align: center;
    font-size: 14px;
    line-height: 2rem;
    width: 3rem;
    height: 2rem;
    margin-left: 1rem;
}

/deep/.el-dialog {
    border-radius: 1rem;
}

.content-box {
    height: 55rem;
    margin-top: 2rem;
    display: flex;

    .left-box {
        height: 100%;
        width: 24rem;
        border: 1px solid #e8ecef;
        padding: 2rem;
        overflow: auto;

        &> :nth-child(n) {
            margin-top: 2rem;
        }

        &> :nth-child(1) {
            margin-top: 0;
        }
    }

    .right-box {
        margin-left: 2rem;
        flex: 1;
        border: 1px solid #e8ecef;
        position: relative;
    }
}

.dialog-footer {
    display: flex;
    justify-content: center;

    &> :nth-child(2) {
        margin-left: 4rem;
    }
}

/deep/#tab-myself {
    padding-left: 2rem !important;
}

/deep/.el-tabs__item {
    height: 6rem;
    line-height: 6rem;
}

/deep/.el-tabs__active-bar {
    height: 3px;
}

/deep/.el-tabs__content {
    height: calc(100% - 6rem);
}

/deep/.el-tabs {
    height: 100%;
}

/deep/.el-tab-pane {
    height: 100%;
}

/deep/.el-tabs__header {
    margin: 0 !important;
}

.left-box-container {
    width: 10rem;
    height: 100%;
    border-right: 1px solid #e8ecef;
    display: flex;
    flex-direction: column;
    align-items: center;

    &> :nth-child(n) {
        margin-top: 3rem;

        i {
            font-size: 2rem;
            cursor: pointer;
        }
    }
}

.right-box-container {
    flex: 1;
    overflow: auto;
    padding: 2rem;
}

.select-box {
    background-color: #CADFF3;
    padding: 0 2rem 1rem 0;
    display: flex;
    margin-bottom: 2rem;
    border-radius: 4px;
    flex-wrap: wrap;
    max-height: 7.5rem;
    overflow: auto;
    .select-item {
        padding: 2px 4px;
        color: #387DFF;
        background-color: rgba(56, 125, 255, 0.2);
        margin-left: 2rem;
        margin-top: 1rem;
    }
}

.box-content {
    height: 100%;
    display: flex;
    width: 100%;
}

.table-box {
    display: flex;
    flex-wrap: wrap;
    align-content: flex-start;
    width: 100%;

    &> :nth-child(n) {
        width: 19rem;
        margin-left: 2rem;
    }

    &> :nth-child(n+5) {
        margin-top: 2rem;
    }

    &> :nth-child(4n+1) {
        margin-left: 0;
    }
}

.cover-box {
    width: 100%;
    aspect-ratio: var(--aspectRatio);
    background: rgba(56, 125, 255, 0.50);
    border-radius: 4px;
}

.select-item {
    display: flex;
    align-items: center;

    i {
        margin-left: 1.5rem;
        margin-top: 0.2rem;
    }
}

.active {
    color: var(--blue) !important;
    font-weight: 700;
}

.tip-box {
    display: flex;
    align-items: center;
    color: var(--blue);
    padding-left: 6rem;
    padding-top: 1rem;
    &> :nth-child(2) {
        margin-left: 0.5rem;
    }
}

/deep/.el-upload {
    width: 100%;
    height: 99%;
}

/deep/.el-upload-dragger {
    height: 100%;
}

.active-select {
    color: var(--blue) !important;
}

.table-item {
    cursor: pointer;
}

.radio-box {
    padding-bottom: 3rem;
    border-bottom: 1px solid #EAEBF0;
    display: flex;
    align-items: center;
    color: #8590B3;

    &> :nth-child(1) {
        margin-top: -4px;
    }
}

.t-cover-box {
    margin-bottom: 3rem;
    display: flex;
    align-items: center;

    &> :nth-child(1) {
        margin-right: 1rem;
    }
}

.upload-box-img {
    /deep/.el-upload {
        width: 50px;
        height: 50px;
        position: relative;
    }

    /deep/.el-icon-plus {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }

    /deep/.el-upload--picture-card {
        border: 1px solid #e8ecef;
        background: #ffffff;
    }
}

.mi-tip-box {
    width: 100%;
    text-align: center;
    margin-top: 20rem;
    font-weight: 700;
    font-size: 14px;
}

.page-box {
    text-align: center;
    width: 100%;
    padding: 2rem 0;
    position: absolute;
    bottom: 0;
    left: 0;
}

.num1 {
    width: 2rem;
    height: 2rem;
    color: #ffffff;
    display: flex;
    font-size: 12px;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    position: absolute;
    top: -1.8rem;
    left: -1rem;
    background-color: red;
}

.num2 {
    position: absolute;
    font-size: 12px;
    top: 0;
    right: -4rem;
    color: #000000;
}

/deep/.table {
    height: 100%;
}

.operation-text {
    color: var(--blue);
    cursor: pointer;
}
.html-ev{
    display: flex;
    align-items: center;
    & :nth-child(n){
        display: flex;
        align-items: center;
        font-size: 14px !important;
    }
    /deep/ img{
        max-width: 2rem !important;
        max-height: 2rem !important;
        width: auto;
        height: auto;
    }
}
.type-img-style{
    width: 2.2rem;
    height: auto;
    cursor: pointer;
}
.search-img{
    cursor: pointer;
    width: 16px;
    position: absolute;
    top: 50%;
    left: 0.5rem;
    transform: translateY(-50%);
}
/deep/.backimg{
    height: calc(100% - 6.9rem);
}
</style>
